import { Modal, Text, type ModalProps } from "@/atoms"
import { Heading } from "@/molecules/Heading"

import styles from "./ModalConfigurationTabVirtualMachineDrawer.module.scss"

export const ModalConfigurationTabVirtualMachineDrawer = (
  props: ModalProps
) => {
  const {
    children,
    title = "Project is correlated with images",
    ...rest
  } = props

  return (
    <Modal
      title={
        <Heading
          level={5}
          capitalize={false}
          title={<Text>{title}</Text>}
          classes={{ title: styles.modalHeaderTitle }}
        />
      }
      classNames={{
        container: styles.modalContainer,
        header: styles.modalHeader,
        body: styles.modalBody,
        footer: styles.modalFooter
      }}
      {...rest}
    >
      {children}
    </Modal>
  )
}
